'use client';

import { useCallback } from 'react';
import { useRouter } from 'next/navigation';
import { Box, Button2, Text, theme } from '@frameio/vapor';
import { IconWarning } from '@frameio/vapor-icons';
import {
  AppUiThemeStaticDark,
  AppUiThemeStaticDarkNeutral,
} from '../contexts/AppUiThemeContext/AppUiThemeStatic';
import { useIsMatchingClientName } from '../contexts/ClientNameContext';
import { getLink } from '../routing';
import TEXT from './generated/TEXT/NotFoundLayout';

TEXT.DEFINE({
  returnHome: 'Return Home',
  notFound: 'Page not found',
});

export function NotFoundLayout({
  notFoundMessage = TEXT.notFound,
}: {
  notFoundMessage?: string;
}) {
  const router = useRouter();
  const isWebClient = useIsMatchingClientName('web');
  const href = getLink({
    page: 'workspaces',
    explicitWorkspacesPath: !isWebClient,
  });

  const AppUIThemeStatic = isWebClient
    ? AppUiThemeStaticDark
    : AppUiThemeStaticDarkNeutral;

  const onPress = useCallback(() => {
    router.push(href);
  }, [router, href]);

  return (
    <AppUIThemeStatic>
      <Box
        alignItems="center"
        backgroundColor="panel"
        borderRadius={8}
        display="flex"
        flexDirection="column"
        gap={16}
        height="100%"
        justifyContent="center"
        textAlign="center"
        width="100%"
      >
        <IconWarning
          aria-hidden={true}
          color={theme.colors.icon.interactive.informative}
          size={24}
        />
        <Text>{notFoundMessage}</Text>
        <Button2 onPress={onPress}>{TEXT.returnHome}</Button2>
      </Box>
    </AppUIThemeStatic>
  );
}
